import { AsyncPipe, DatePipe, NgClass, NgFor, NgIf } from "@angular/common";
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Inject,
  Input,
  Optional,
  Output,
  TrackByFunction
} from "@angular/core";
import { EneLayoutService } from "src/app/core/services/layout.service";
import { Store } from "@ngrx/store";
import { TranslateModule } from "@ngx-translate/core";
import { ColoredBadgeModule } from "src/app/common/components/colored-badge/colored-badge.module";
import { IconModule } from "src/app/shared/ui/icon/icon.module";
import { MediaPlayerModule } from "src/app/common/components/media-player/media-player.module";
import { ContentfulActionField } from "src/app/core/interfaces/contentful";
import { OVERLAY_DATA, OverlayService } from "src/app/core/services/overlay.service";
import { QueryParamsManagerService } from "src/app/core/services/query-params-manager.service";
import { RootState } from "src/app/ngrx/root-reducers";
import { ButtonComponent } from "src/app/shared/ui/button/button.component";
import { EneButtonModule } from "src/app/shared/ui/button/legacy/button.module";
import { NewsActionsManagerService } from "../../news-actions-manager.service";
import { CommunalPlatformNewsEntry, NetzeBwNewsEntry } from "../../news.interfaces";

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: "tpm-card-news-details",
  templateUrl: "./card-news-details.component.html",
  styleUrls: ["./card-news-details.component.scss"],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    NgIf,
    NgFor,
    NgClass,
    AsyncPipe,
    DatePipe,
    IconModule,
    EneButtonModule,
    ColoredBadgeModule,
    MediaPlayerModule,
    ButtonComponent,
    TranslateModule
  ]
})
export class CardNewsDetailsComponent {
  readonly isMobileView$ = this.layoutService.isMobileScreen$;

  @Input() selected: NetzeBwNewsEntry | CommunalPlatformNewsEntry | null = null;

  @Output() readonly close = new EventEmitter<void>();

  get selectedEntry(): NetzeBwNewsEntry | CommunalPlatformNewsEntry | null {
    return this.selected ?? this.data?.selected ?? null;
  }

  constructor(
    @Optional()
    @Inject(OVERLAY_DATA)
    readonly data: { selected: NetzeBwNewsEntry } | null,
    private readonly store: Store<RootState>,
    private readonly layoutService: EneLayoutService,
    private readonly overlayService: OverlayService,
    private readonly newsActionsManagerService: NewsActionsManagerService,
    private readonly queryParamsManagerService: QueryParamsManagerService
  ) {}

  readonly trackByLabel: TrackByFunction<{ label: string }> = (_, item): string => item.label;

  onActionClick(actionField: ContentfulActionField): void {
    this.newsActionsManagerService.dispatch(actionField.action, actionField.url);
  }

  onClose(): void {
    if (this.data) {
      this.overlayService.close(CardNewsDetailsComponent);
      this.queryParamsManagerService.removeQueryParams();
      this.close.emit();
    } else {
      this.close.emit();
    }
  }
}
